import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
// import { headers, platform } from '../../Utils';
import {
  clearAlbum,
  clearAllPhotos,
  clearMyPhotos,
  getAlbum,
  getAllPhotos,
  getEventGalleryCategories,
  getMyPhotos,
  updateMyPhotos,
} from "../Actions/PhotosActions";
// import RNFetchBlob from 'rn-fetch-blob'
import { headers } from "../../utills";

export const PhotosMiddleware = {
  getAllPhotos: (gallery_data) => {
    return (dispatch) => {
      if (gallery_data?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (
            gallery_data?.search ||
            gallery_data?.next_page_url == undefined
          ) {
            if (gallery_data?.search && gallery_data?.next_page_url) {
            } else {
              dispatch(clearAllPhotos());
            }
          }
          let formData = new FormData();
          formData.append("event_id", gallery_data?.event_id);
          if (gallery_data?.search)
            formData.append("user_name", gallery_data?.search);
          const data = await Axios.post(
            Apis.getAllGalleryPhotos(gallery_data?.next_page_url),
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getAllPhotos(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getAllPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getAlbumPhotos: (album_data) => {
    return (dispatch) => {
      if (album_data?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (album_data?.next_page_url == undefined) {
            dispatch(clearAlbum());
          }
          let formData = new FormData();
          formData.append("event_id", album_data?.event_id);
          formData.append("user_id", album_data?.user_id);
          const data = await Axios.post(
            Apis.getAllGalleryPhotosByUser(album_data?.next_page_url),
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            // console.log("galleryData", data?.data?.data?.attachments);
            resolve(true);
            dispatch(getAlbum(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getAlbumPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getEventGalleryCategories: (categoryData) => {
    // console.log("categoryData", categoryData);
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getEventGalleryCategories(categoryData?.event_id),
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(getEventGalleryCategories(data?.data?.data));
            console.log("data?.data?.data", data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getMyPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  createEventGalleryCategory: (categoryData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", categoryData?.event_id);
          formData.append("name", categoryData?.name);
          const data = await Axios.post(
            Apis.createEventGalleryCategory,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
          }
        } catch (error) {
          // console.log("error", error);
          reject(error);
          dispatch(
            showAlert({
              title: "getMyPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getMyPhotos: (gallery_data) => {
    return (dispatch) => {
      if (gallery_data?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (
            gallery_data?.search ||
            gallery_data?.next_page_url == undefined
          ) {
            if (gallery_data?.search && gallery_data?.next_page_url) {
            } else {
              dispatch(clearMyPhotos());
            }
          }
          let formData = new FormData();
          formData.append("event_id", gallery_data?.event_id);
          if (gallery_data?.search)
            formData.append("name", gallery_data?.search);

          const data = await Axios.post(
            Apis.getGalleryPhotos(gallery_data?.next_page_url),
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            // console.log("dataaa", data?.data?.data);
            // if (data?.data?.data?.data) {
              dispatch(getMyPhotos(data?.data?.data));
            // }
            // console.log('dataaaaaaa', data);
            // console.log('====================================');
            // console.log(JSON.stringify(data?.data?.data, null, 8));
            // console.log('====================================');
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getMyPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  uploadGallery: (gallery_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", gallery_data?.event_id);
          formData.append("category_id", gallery_data?.category_id);
          for (const [i, element] of gallery_data?.media.entries()) {
            formData.append(`attachements[${i}][file]`, element?.media);
            formData.append(`attachements[${i}][type]`, element?.media_type);
            if (element?.thumbnail)
              formData.append(
                `attachements[${i}][thumbnail]`,
                element?.thumbnail
              );
          }
          const data = await Axios.post(
            Apis.createGalleryPhotos,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(
              PhotosMiddleware.getEventGalleryCategories({
                event_id: gallery_data.event_id,
              })
            );
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            // dispatch(updateMyPhotos(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getMyPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  // DownloadAttachment: ({ selectedItem }) => {
  //     let extension = selectedItem.video.split('.')
  //     let title = selectedItem.title + '.' + extension[extension.length - 1]
  //     let dirs = RNFetchBlob.fs.dirs
  //     return async dispatch => {
  //         // dispatch(showLoading())
  //         await RNFetchBlob
  //             .config({
  //                 timeout: 60 * 60,
  //                 fileCache: true,
  //                 path: dirs.DownloadDir + '/' + selectedItem,
  //                 addAndroidDownloads: {
  //                     useDownloadManager: true,
  //                     notification: true,
  //                     // mime: 'application/pdf',
  //                     // title: title,
  //                     path: platform.OS == 'ios' ? dirs.DocumentDir + '/' + title : dirs.DownloadDir + '/' + title,
  //                 },
  //             })
  //             .fetch("GET", selectedItem.video,
  //                 headers.config(),
  //             )
  //             .then((res) => {
  //                 platform.OS == 'ios' ? RNFetchBlob.ios.openDocument(res.data)
  //                     :
  //                     null;

  //             }).catch((err) => {
  //                 console.warn(err);
  //             })

  //     };
  // },

  MoveIGPhotosToGallery: (temp) => {
    // console.log('temp', temp);
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        dispatch(showLoading());
        try {
          let formData = new FormData();
          formData.append("event_id", temp?.event_id);
          formData.append("id", temp?.id);

          const data = await Axios.post(
            Apis.moveInspirationalPhotoToGallery,
            formData,
            await headers.config()
          );

          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
          }
        } catch (error) {
          //   console.log('error', error.response?.data?.message);
          reject(error);
          dispatch(
            showAlert({
              title: "getMyPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
